import React from "react";
import { createSvgIconComponent } from "../utils";
/**
 * Always refer to https://developers.google.com/pay/api/android/guides/brand-guidelines when consuming this icon
 */

import { jsx as ___EmotionJSX } from "@emotion/react";
export var IconGooglePay = createSvgIconComponent({
  children: [___EmotionJSX("path", {
    key: "part-1",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Base_1_",
    fill: "#FFFFFF",
    d: "M 584.552 36.031 L 232.552 36.031 C 122.552 36.031 32.552 126.031 32.552 236.031 C 32.552 346.031 122.552 436.031 232.552 436.031 L 584.552 436.031 C 694.552 436.031 784.552 346.031 784.552 236.031 C 784.552 126.031 694.552 36.031 584.552 36.031 Z"
  }), ___EmotionJSX("path", {
    key: "part-2",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Outline",
    fill: "#3C4043",
    d: "M 584.552 52.231 C 609.252 52.231 633.252 57.131 655.852 66.731 C 677.752 76.031 697.352 89.331 714.352 106.231 C 731.252 123.131 744.552 142.831 753.852 164.731 C 763.452 187.331 768.352 211.331 768.352 236.031 C 768.352 260.731 763.452 284.731 753.852 307.331 C 744.552 329.231 731.252 348.831 714.352 365.831 C 697.452 382.731 677.752 396.031 655.852 405.331 C 633.252 414.931 609.252 419.831 584.552 419.831 L 232.552 419.831 C 207.852 419.831 183.852 414.931 161.252 405.331 C 139.352 396.031 119.752 382.731 102.752 365.831 C 85.852 348.931 72.552 329.231 63.252 307.331 C 53.652 284.731 48.752 260.731 48.752 236.031 C 48.752 211.331 53.652 187.331 63.252 164.731 C 72.552 142.831 85.852 123.231 102.752 106.231 C 119.652 89.331 139.352 76.031 161.252 66.731 C 183.852 57.131 207.852 52.231 232.552 52.231 L 584.552 52.231 M 584.552 36.031 L 232.552 36.031 C 122.552 36.031 32.552 126.031 32.552 236.031 C 32.552 346.031 122.552 436.031 232.552 436.031 L 584.552 436.031 C 694.552 436.031 784.552 346.031 784.552 236.031 C 784.552 126.031 694.552 36.031 584.552 36.031 Z"
  }), ___EmotionJSX("g", {
    key: "part-3",
    xmlns: "http://www.w3.org/2000/svg",
    id: "G_Pay_Lockup_1_",
    transform: "matrix(1, 0, 0, 1, -138.148682, -133.968933)"
  }, ___EmotionJSX("g", {
    id: "Pay_Typeface_3_"
  }, ___EmotionJSX("path", {
    id: "Letter_p_3_",
    fill: "#3C4043",
    d: "M529.3,384.2v60.5h-19.2V295.3H561c12.9,0,23.9,4.3,32.9,12.9 c9.2,8.6,13.8,19.1,13.8,31.5c0,12.7-4.6,23.2-13.8,31.7c-8.9,8.5-19.9,12.7-32.9,12.7h-31.7V384.2z M529.3,313.7v52.1h32.1 c7.6,0,14-2.6,19-7.7c5.1-5.1,7.7-11.3,7.7-18.3c0-6.9-2.6-13-7.7-18.1c-5-5.3-11.3-7.9-19-7.9h-32.1V313.7z"
  }), ___EmotionJSX("path", {
    id: "Letter_a_3_",
    fill: "#3C4043",
    d: "M657.9,339.1c14.2,0,25.4,3.8,33.6,11.4c8.2,7.6,12.3,18,12.3,31.2v63h-18.3v-14.2h-0.8 c-7.9,11.7-18.5,17.5-31.7,17.5c-11.3,0-20.7-3.3-28.3-10s-11.4-15-11.4-25c0-10.6,4-19,12-25.2c8-6.3,18.7-9.4,32-9.4 c11.4,0,20.8,2.1,28.1,6.3v-4.4c0-6.7-2.6-12.3-7.9-17c-5.3-4.7-11.5-7-18.6-7c-10.7,0-19.2,4.5-25.4,13.6l-16.9-10.6 C625.9,345.8,639.7,339.1,657.9,339.1z M633.1,413.3c0,5,2.1,9.2,6.4,12.5c4.2,3.3,9.2,5,14.9,5c8.1,0,15.3-3,21.6-9 s9.5-13,9.5-21.1c-6-4.7-14.3-7.1-25-7.1c-7.8,0-14.3,1.9-19.5,5.6C635.7,403.1,633.1,407.8,633.1,413.3z"
  }), ___EmotionJSX("path", {
    id: "Letter_y_3_",
    fill: "#3C4043",
    d: "M808.2,342.4l-64,147.2h-19.8l23.8-51.5L706,342.4h20.9l30.4,73.4h0.4l29.6-73.4H808.2z"
  })), ___EmotionJSX("g", {
    id: "G_Mark_1_"
  }, ___EmotionJSX("path", {
    id: "Blue_500",
    fill: "#4285F4",
    d: "M452.93,372c0-6.26-0.56-12.25-1.6-18.01h-80.48v33L417.2,387 c-1.88,10.98-7.93,20.34-17.2,26.58v21.41h27.59C443.7,420.08,452.93,398.04,452.93,372z"
  }), ___EmotionJSX("path", {
    id: "Green_500_1_",
    fill: "#34A853",
    d: "M400.01,413.58c-7.68,5.18-17.57,8.21-29.14,8.21c-22.35,0-41.31-15.06-48.1-35.36 h-28.46v22.08c14.1,27.98,43.08,47.18,76.56,47.18c23.14,0,42.58-7.61,56.73-20.71L400.01,413.58z"
  }), ___EmotionJSX("path", {
    id: "Yellow_500_1_",
    fill: "#FABB05",
    d: "M320.09,370.05c0-5.7,0.95-11.21,2.68-16.39v-22.08h-28.46 c-5.83,11.57-9.11,24.63-9.11,38.47s3.29,26.9,9.11,38.47l28.46-22.08C321.04,381.26,320.09,375.75,320.09,370.05z"
  }), ___EmotionJSX("path", {
    id: "Red_500",
    fill: "#E94235",
    d: "M370.87,318.3c12.63,0,23.94,4.35,32.87,12.85l24.45-24.43 c-14.85-13.83-34.21-22.32-57.32-22.32c-33.47,0-62.46,19.2-76.56,47.18l28.46,22.08C329.56,333.36,348.52,318.3,370.87,318.3z"
  })))],
  viewBox: "0 0 820 470",
  x: "0px",
  y: "0px",
  xmlSpace: "preserve",
  enableBackground: "new 0 0 1094 742"
});